/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const ForwardSmallIcon = ({ width = 15, height = 16, color = '#fff', children, ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 15 16' fill={color} {...props} xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.3963 0.354821C11.201 0.550083 11.201 0.866665 11.3963 1.06193L12.3136 1.97921H7.49984C3.89848 1.97921 0.979004 4.89868 0.979004 8.50004C0.979004 12.1014 3.89848 15.0209 7.49984 15.0209C11.1012 15.0209 14.0207 12.1014 14.0207 8.50004C14.0207 8.2239 13.7968 8.00004 13.5207 8.00004C13.2445 8.00004 13.0207 8.2239 13.0207 8.50004C13.0207 11.5491 10.5489 14.0209 7.49984 14.0209C4.45076 14.0209 1.979 11.5491 1.979 8.50004C1.979 5.45097 4.45076 2.97921 7.49984 2.97921H12.3136L11.3963 3.89649C11.201 4.09175 11.201 4.40833 11.3963 4.60359C11.5915 4.79886 11.9081 4.79886 12.1034 4.60359L13.8742 2.83276C13.968 2.73899 14.0207 2.61182 14.0207 2.47921C14.0207 2.3466 13.968 2.21942 13.8742 2.12565L12.1034 0.354821C11.9081 0.159558 11.5915 0.159558 11.3963 0.354821Z'
    />
    <text x='50%' y='55%' fontSize={6} dominantBaseline='middle' textAnchor='middle'>
      {children}
    </text>
  </svg>
);

export default ForwardSmallIcon;
